module.exports = __webpack_public_path__ + "static/media/ms365mail.a32343c3.png";